export type ToastKind = "success" | "error" | "info" | "warning";

export interface ToastMessage {
  readonly id: string;
  readonly kind: ToastKind;
  readonly title: string;
  readonly description?: string;
}

type ToastListener = (message: ToastMessage) => void;
const listeners = new Set<ToastListener>();
let nextId = 0;

export function subscribeToToasts(listener: ToastListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function publishToast(message: Omit<ToastMessage, "id">): string {
  const id = `toast-${String(++nextId)}`;
  const toast = { ...message, id };
  for (const listener of listeners) listener(toast);
  return id;
}
